import '../PublicPage.css';

export default function TopDestinationsPage() {
    return (
        <div className="public-page seo-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>Top Travel Destinations for 2026</h1>
                    <p>Discover where the world is going next with Raisa AI.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="destinations-list-grid" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                        gap: '32px',
                    }}>
                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1523906834658-6e24ef2386f9.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/italy'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Italy</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Art, pasta, and stunning landscapes.</p>
                            <span style={{ fontWeight: '700' }}>Explore Italy Guides →</span>
                        </div>

                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1543722530-d2c3201371e7.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/spain'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Spain</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Flamenco, tapas, and sun-drenched beaches.</p>
                            <span style={{ fontWeight: '700' }}>Explore Spain Guides →</span>
                        </div>

                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1555881400-74d7acaacd8b.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/portugal'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Portugal</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Azulejos, fado, and Atlantic charm.</p>
                            <span style={{ fontWeight: '700' }}>Explore Portugal Guides →</span>
                        </div>

                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1537996194471-e657df975ab4.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/indonesia'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Indonesia</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Tropical islands and spiritual retreats.</p>
                            <span style={{ fontWeight: '700' }}>Explore Indonesia Guides →</span>
                        </div>

                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1467269204594-9661b134dd2b.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/germany'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Germany</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Fairytale castles and modern efficiency.</p>
                            <span style={{ fontWeight: '700' }}>Explore Germany Guides →</span>
                        </div>

                        <div className="modern-card pillar-link-card" style={{
                            backgroundImage: 'linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.6)), url(/images/photo-1512453979798-5ea266f8880c.jpg',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '400px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-end',
                            color: 'white',
                            cursor: 'pointer',
                            border: 'none'
                        }} onClick={() => window.location.href = '/dubai'}>
                            <h3 style={{ color: 'white', marginBottom: '8px', fontSize: '2rem' }}>Dubai</h3>
                            <p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '16px' }}>Modern wonders and luxury shopping.</p>
                            <span style={{ fontWeight: '700' }}>Explore Dubai Guides →</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
